import { render, staticRenderFns } from "./BadgeList.vue?vue&type=template&id=5d1d8f3a&scoped=true"
var script = {}
import style0 from "./BadgeList.vue?vue&type=style&index=0&id=5d1d8f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d8f3a",
  null
  
)

export default component.exports